import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 19 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M17.39 1.606c-2.083-2.142-5.412-2.141-7.494.001l-8.731 9.179c-1.58 1.699-1.549 4.421.067 6.08a3.95 3.95 0 0 0 5.718 0l7.906-8.31c1.028-1.081 1.028-2.833 0-3.913a2.54 2.54 0 0 0-3.722 0l-7.563 7.95a.75.75 0 0 0 .017 1.021c.266.271.689.271.955 0l7.563-7.95a1.215 1.215 0 0 1 1.778.04 1.37 1.37 0 0 1 0 1.83l-7.907 8.31a2.623 2.623 0 0 1-3.84-.028c-1.042-1.112-1.042-2.897 0-4.008l8.731-9.179a3.85 3.85 0 0 1 5.634-.001c1.556 1.635 1.556 4.286 0 5.922l-8.73 9.178a.75.75 0 0 0-.076 1.02.665.665 0 0 0 1.045 0l8.731-9.18c2.07-2.222 2.032-5.787-.082-7.962" }, null, -1)
  ])))
}
export default { render: render }